module.exports = __webpack_public_path__ + "media/images/redrock/purple_back-d522dd5ad30b80a28f1f1477a881f29d.jpg";